import { getActiveMsalInstance } from "../authConfig"
import { useEffect, useState } from 'react'

export function useProfilePhoto() {
    const instance = getActiveMsalInstance()
    const [url, setUrl] = useState<string | null>(null)

    useEffect(() => {
        const account = instance.getActiveAccount()
        if (!account) return

        instance
            .acquireTokenSilent({ account, scopes: ['User.Read'] })
            .then(r =>
                fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
                    headers: { Authorization: `Bearer ${r.accessToken}` },
                }),
            )
            .then(res => (res.ok ? res.blob() : null))
            .then(b => {
                if (b) setUrl(URL.createObjectURL(b))
            })
            .catch(err => {
                console.warn("Failed to load profile photo:", err)
            })
    }, [instance])

    return url
}
